<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>
            {{ $t('汽车门店.门店名称') }}<template slot="title">{{ $t('汽车门店.门店名称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="150" :placeholder="$t('通用.输入.请输入') + $t('汽车门店.门店名称')" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="picture" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('汽车门店.图片')}}<template slot="title">{{$t('汽车门店.图片')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.picture" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('汽车门店.图片')" />-->
      <!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('汽车门店.图片')" prop="picture">
        <a-upload
          name="picture"
          listType="picture-card"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload"
        >
          <img v-if="form.picture" :src="form.picture" alt="picture" style="height: 102px; width: 102px" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
          </div>
        </a-upload>
        <span>推荐尺寸 351 x 175</span>
      </a-form-model-item>

      <a-form-model-item prop="address">
        <span slot="label">
          <a-tooltip>
            {{ $t('汽车门店.详细地址') }}<template slot="title">{{ $t('汽车门店.详细地址') }}</template>
          </a-tooltip>
        </span>
        <a-input-group compact>
          <a-input
            v-model="form.address"
            style="width: 80%"
            :maxLength="255"
            :placeholder="$t('通用.输入.请输入') + $t('汽车门店.详细地址')"
            readonly
          />
          <a-button type="primary" style="width: 20%" @click="showMapModal"> 选择位置 </a-button>
        </a-input-group>
        <div style="margin-top: 8px">
          <span style="margin-right: 8px">经度: {{ form.lng }}</span>
          <span>纬度: {{ form.lat }}</span>
        </div>
      </a-form-model-item>
      <a-form-model-item prop="phone">
        <span slot="label">
          <a-tooltip>
            {{ $t('汽车门店.联系电话') }}<template slot="title">{{ $t('汽车门店.联系电话') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.phone" :maxLength="50" :placeholder="$t('通用.输入.请输入') + $t('汽车门店.联系电话')" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="source" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('汽车门店.门店来源 10:后台录入 20:系统同步')}}<template slot="title">{{$t('汽车门店.门店来源 10:后台录入 20:系统同步')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.source"  :placeholder="$t('通用.输入.请输入')+$t('汽车门店.门店来源 10:后台录入 20:系统同步')" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item prop="sort">
        <span slot="label">
          <a-tooltip>
            {{ $t('汽车门店.排序') }}<template slot="title">{{ $t('汽车门店.排序') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sort" :placeholder="$t('通用.输入.请输入') + $t('汽车门店.排序')" />
      </a-form-model-item>
      <!--      <a-form-model-item prop="remark" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('汽车门店.备注')}}<template slot="title">{{$t('汽车门店.备注')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <a-modal title="选择位置" :visible="mapVisible" :width="800" @ok="handleMapOk" @cancel="handleMapCancel">
        <div class="map-container">
          <div id="container" style="height: 500px"></div>
          <div class="map-search-box">
            <a-input-search
              v-model="searchAddress"
              placeholder="请输入地址搜索"
              style="width: 300px"
              @search="searchLocation"
              enterButton
            />
            <div v-if="searchResults.length > 0" class="search-results">
              <a-list size="small" bordered>
                <a-list-item
                  v-for="(item, index) in searchResults"
                  :key="index"
                  class="search-item"
                  @click="selectSearchResult(item)"
                >
                  {{ item.address }}
                </a-list-item>
              </a-list>
            </div>
          </div>
        </div>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCarShop, addCarShop, updateCarShop } from '@/api/carShop/carShop'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, generateRdStr, uploadObject, uploadOss } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        picture: null,

        address: null,

        phone: null,

        lng: null,

        lat: null,

        source: null,

        sort: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: this.$t('汽车门店.门店名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        address: [
          { required: true, message: this.$t('汽车门店.详细地址') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
        phone: [
          { required: true, message: this.$t('汽车门店.联系电话') + this.$t('通用.文本.不能为空'), trigger: 'blur' },
        ],
      },
      mapVisible: false,
      map: null,
      marker: null,
      searchAddress: '',
      searchResults: [],
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        picture: null,
        address: null,
        phone: null,
        lng: null,
        lat: null,
        source: null,
        sort: null,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCarShop({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateCarShop(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addCarShop(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    showMapModal() {
      this.mapVisible = true
      this.$nextTick(() => {
        // 等待地图加载完成
        window.initAMapPromise
          .then(() => {
            if (!this.map) {
              this.initMap()
            }
          })
          .catch((error) => {
            console.error('地图加载失败:', error)
            this.$message.error('地图加载失败，请刷新重试')
          })
      })
    },
    initMap() {
      try {
        if (!window.AMap) {
          this.$message.error('地图未加载完成，请刷新重试')
          return
        }

        // 创建地图实例
        this.map = new window.AMap.Map('container', {
          zoom: 13,
          center: [this.form.lng || 116.397428, this.form.lat || 39.90923],
          resizeEnable: true,
          viewMode: '2D',
        })

        // 先加载插件
        window.AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.Geocoder', 'AMap.PlaceSearch'], () => {
          // 添加工具条和比例尺
          const toolBar = new window.AMap.ToolBar()
          const scale = new window.AMap.Scale()
          this.map.addControl(toolBar)
          this.map.addControl(scale)

          // 添加点击事件
          this.map.on('click', (e) => {
            const lnglat = e.lnglat
            this.updateMarkerAndAddress(lnglat)
          })

          // 如果已有经纬度，添加标记
          if (this.form.lng && this.form.lat) {
            this.updateMarkerAndAddress(new window.AMap.LngLat(this.form.lng, this.form.lat))
          }
        })
      } catch (error) {
        console.error('地图初始化失败:', error)
        this.$message.error('地图加载失败，请刷新重试')
      }
    },
    updateMarkerAndAddress(lnglat) {
      // 更新经纬度
      this.form.lng = lnglat.getLng().toFixed(6)
      this.form.lat = lnglat.getLat().toFixed(6)

      // 更新标记
      if (!this.marker) {
        this.marker = new window.AMap.Marker({
          position: lnglat,
          map: this.map,
          animation: 'AMAP_ANIMATION_DROP',
        })
      } else {
        this.marker.setPosition(lnglat)
      }

      // 获取地址
      const geocoder = new window.AMap.Geocoder({
        radius: 1000,
        extensions: 'all',
      })

      geocoder.getAddress([lnglat.getLng(), lnglat.getLat()], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.form.address = result.regeocode.formattedAddress
        } else {
          this.$message.error('获取地址失败')
        }
      })
    },
    searchLocation() {
      if (!this.searchAddress) {
        this.searchResults = []
        return
      }

      const placeSearch = new window.AMap.PlaceSearch({
        pageSize: 5,
        pageIndex: 1,
        city: '全国',
      })

      placeSearch.search(this.searchAddress, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.searchResults = result.poiList.pois
        } else {
          this.searchResults = []
          this.$message.error('地址查询失败')
        }
      })
    },
    selectSearchResult(item) {
      const location = item.location
      this.map.setCenter([location.lng, location.lat])
      this.updateMarkerAndAddress(new window.AMap.LngLat(location.lng, location.lat))
      this.searchResults = []
      this.searchAddress = ''
    },
    handleMapOk() {
      this.mapVisible = false
    },
    handleMapCancel() {
      this.mapVisible = false
    },

    //上传图片
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then((res) => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('通用.文本.上传成功'))
        })
      })
    },
    coverDetailImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'activity'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then((res) => {
          _this.$set(_this.form, 'posterPic', res)
          _this.$message.success(this.$t('通用.文本.上传成功'))
        })
      })
    },
    //上传图片
  },
}
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 500px;
}

.map-search-box {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
  background: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.search-results {
  position: absolute;
  width: 300px;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  margin-top: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.search-item {
  cursor: pointer;
  padding: 8px 12px;
}

.search-item:hover {
  background: #e6f7ff;
}
</style>
